import { createAsyncThunk, createSlice,PayloadAction } from '@reduxjs/toolkit';
import { Status } from '../../../common/constants';
import api from '../../../api';
import { getCookie } from "../../../common/utils";
import {ImobileLicenseSliceState,IAddOrUpdateLicensePayload } from '../../../common/types/mobileLicensingTypes';
import { addOrManageMobileLicenseUrl, revokeMobileLicenseUrl } from '../../../config';

const initialState: ImobileLicenseSliceState = {
  message:"",
  status: Status.IDLE,
  error: null
};

export const addOrManageMobileLicense = createAsyncThunk(
  "mobileLicensing/addOrManage",
  async (
    payload: IAddOrUpdateLicensePayload,
    { rejectWithValue }
  ) => {
    try {
      const organizationId = payload.orgId ;
      const response = await api.put(addOrManageMobileLicenseUrl, {
        orgId: organizationId,
        expireDate: payload.expireDate,
        totalLicenseCount: payload.totalLicenseCount,
      });
      return response.data.message;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message ?? error.message ?? "Something went wrong"
      );
    }
  }
);

export const disableMobileLicense = createAsyncThunk(
  "mobileLicensing/disable",
  async (orgId: string, { rejectWithValue }) => {
    try {
      const organizationId = orgId ?? getCookie("organizationId");
      const response = await api.put(`${revokeMobileLicenseUrl}?orgId=${organizationId}`);
      return response.data.message;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message ?? error.message ?? "Something went wrong"
      );
    }
  }
);

const mobileLicensingSlice = createSlice({
  name: "mobileLicensing",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addOrManageMobileLicense.pending, (state) => {
        state.status = Status.PENDING;
      })
      .addCase(addOrManageMobileLicense.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
      })
      .addCase(addOrManageMobileLicense.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error =
          (action.payload as string) ??
          action.error.message ??
          "Something went wrong";
      })
      .addCase(disableMobileLicense.pending, (state) => {
        state.status = Status.PENDING;
      })
      .addCase(disableMobileLicense.fulfilled, (state) => {
        state.status = Status.SUCCESS;
      })
      .addCase(disableMobileLicense.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error =
          (action.payload as string) ??
          action.error.message ??
          "Something went wrong";
      });
  },
});

export default mobileLicensingSlice.reducer;
type Selector = {
  mobileLicensing: ReturnType<typeof mobileLicensingSlice.reducer>;
};

export const selector = (store: Selector) => store['mobileLicensing'];

